import { useQueries } from '@tanstack/react-query';

import { apiQuery } from '../../state';
import type { ContentEditorContextValue } from '../ContentEditor/contexts';

/**
 * Fetch data necessary to display integrations in the editor.
 */
export function useContentEditorIntegrationData(props: {
    spaceId: string;
    organizationId: string;
}): ContentEditorContextValue['integrationData'] {
    return useQueries({
        queries: [
            apiQuery('listSpaceIntegrationsBlocks', {
                spaceId: props.spaceId,
            }),
            apiQuery(
                'listOrganizationIntegrations',
                { organizationId: props.organizationId, blocks: true, limit: 100 },
                { nullOnError: true }
            ),
        ],
        combine: (result) => {
            return {
                integrationBlocks: result[0].data ?? [],
                integrationsWithBlocks: result[1].data?.items ?? [],
            };
        },
    });
}
